// src/components/WorkoutExerciseDetail.js
import { FiCheck as CheckIcon, FiX as XIcon } from "react-icons/fi";
import PickerComponent from "./PickerComponent";

export default function WorkoutExerciseDetail({
  activeExercise,
  sets,
  editTarget,
  onOpenPicker,
  onClosePicker,
  onConfirmPicker,
  onBack,
  onSave,
  onRemove,
}) {
  return (
    <div className="panel panel--stretch detail-view glass">
      <h3>{activeExercise?.name || "Exercise"}</h3>

      <button className="back-btn" type="button" onClick={onBack}>
        ← Back to list
      </button>

      <div className="sets-list">
        {sets.map((s, idx) => {
          const hasAny = s.reps !== "" || s.weight !== "";
          const rowHighlight = hasAny ? "green-border" : "";

          return (
            <div key={idx}>
              <div className="set-row set-row--centered">
                <span className="set-label">Set {idx + 1}</span>

                <button
                  type="button"
                  className={`picker-cell ${rowHighlight}`}
                  onClick={() => onOpenPicker(idx)}
                >
                  {s.reps === "" ? "Reps" : s.reps}
                </button>

                <button
                  type="button"
                  className={`picker-cell ${rowHighlight}`}
                  onClick={() => onOpenPicker(idx)}
                >
                  {s.weight === "" ? "Weight" : `${s.weight} kg`}
                </button>
              </div>
            </div>
          );
        })}
      </div>

      <PickerComponent
        open={!!editTarget}
        title={editTarget ? `Set ${editTarget.idx + 1}` : ""}
        repsValue={editTarget ? sets?.[editTarget.idx]?.reps : ""}
        weightValue={editTarget ? sets?.[editTarget.idx]?.weight : ""}
        onCancel={onClosePicker}
        onConfirm={onConfirmPicker}
      />

      <div className="actions-footer">
        <button className="chip icon-btn chip--confirm large" title="Save sets" type="button" onClick={onSave}>
          <CheckIcon size={28} />
        </button>

        <button className="chip icon-btn chip--remove large" title="Remove exercise" type="button" onClick={onRemove}>
          <XIcon size={28} />
        </button>
      </div>
    </div>
  );
}